import clsx from "clsx";
import React from "react";
import { useTranslation } from "react-i18next";

const TableFooter = (props: { count: number; total: number }) => {
  const { t } = useTranslation();

  return (
    <div
      className={clsx(
        "bg-gray-50 border-t border-gray-200 text-gray-500 px-4 py-2 text-xs font-medium absolute bottom-0 z-2 w-full"
      )}
    >
      {t("productSearch.rowsCount", {
        count: props.count,
        total: props.total,
      })}
    </div>
  );
};

export default TableFooter;
